import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, InputAdornment } from "@mui/material";
import { serverAddr } from "../../networkConfig";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchCoin({ onSelect, onClear }) {
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchSearch(inputValue);
    }, 400);

    return () => clearTimeout(delay);
  }, [inputValue]);

  const fetchSearch = async (text) => {
    try {
      setLoading(true);
      setHasSearched(false); // reset before call

      const response = await serverAddr.post(
        "/publisher/get_crypto_coins_details/",
        {
          page_no: 1,
          page_per_entries: 5,
          search: text
        }
      );

      const data =
        response.data?.data ||
        response.data?.result ||
        response.data ||
        [];

      const formatted = data.map((item) => ({
        id: item.id,
        name: item.title || "",
        price: item.price,
        change: item.price_change,
        date: item.timestamp,
        confidenceScore: item.confidence_score || 2,
        markPrice: item.mark_price,
        backendLeverage: item.leverage,
        is_active_reco: item.is_active_reco,
      }));

      setOptions(formatted);
      setHasSearched(true); // mark search completed

    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="search-coin-container">
      <Autocomplete
        options={options}
        loading={loading}
        getOptionLabel={(option) => option.name || ""}
        open={open}

        onOpen={() => {
          if (inputValue) setOpen(true);
        }}

        onClose={() => setOpen(false)}

        noOptionsText={
          loading
            ? "Loading..."
            : hasSearched && inputValue
              ? "No results found"
              : ""
        }

        onChange={(event, value) => {
          if (value) {
            onSelect(value);
            setInputValue(value.name);
            setOptions([]);
            setOpen(false); // force close
          }
        }}

        inputValue={inputValue}

        onInputChange={(_, newInputValue) => {
          setInputValue(newInputValue);

          if (newInputValue) {
            setOpen(true);
            setOptions([]); // clear old results immediately
          } else {
            setOpen(false);
            if (onClear) onClear();
          }
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Crypto coins eg. Bitcoin"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#8b8fa3", fontSize: 18 }} />
                </InputAdornment>
              ),
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
        // InputLabelProps={{ shrink: false }}

        sx={{
          "& .MuiAutocomplete-clearIndicator": {
            color: "white",
          },
          "& .MuiAutocomplete-popupIndicator": {
            color: "white",
          },
          width: 300,
          "& .MuiOutlinedInput-root": {
            borderRadius: "30px",
            padding: "0 10px",
            "& fieldset": {
              border: "1px solid white",
              borderRadius: "30px",
            },
            "&:hover fieldset": {
              border: "1px solid white",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid white",
            },
          },
        }}

      />
    </div>
  );
}